import { render } from "./aboutschool.vue?vue&type=template&id=1e7d535d&scoped=true"
import script from "./aboutschool.vue?vue&type=script&lang=js"
export * from "./aboutschool.vue?vue&type=script&lang=js"

import "./aboutschool.vue?vue&type=style&index=0&id=1e7d535d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7d535d"]])

export default __exports__